import styled from "styled-components";

const InputWrapper = styled.form`
  /* margin-bottom: 2rem; */

  .search__header__con {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #ccc;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
  }

  .all__search {
    /* border: 2px solid red; */
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    transition: ease-in-out 0.3s all;
  }
  .all__jobs__search {
    /* min-height: 200px; */
    margin-top: 8px;
  }
  .add__all__jobs__search {
    height: 0;
    overflow-y: hidden;
  }
  @media screen and (max-width: 640px) {
    .all__jobs__search {
      grid-template-columns: 1fr;
    }
  }

  .role__one,
  .last__role {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
  }
  @media screen and (max-width: 720px) {
    /* grid-template-columns: 1fr; */
    .role__one,
    .last__role {
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }

  input {
    width: 100%;
    height: 40px;
    padding-inline: 10px;
    font-size: 15px;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  input::placeholder {
    font-size: 14px;
  }
  .profile__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
  @media screen and (max-width: 720px) {
    .profile__container {
      gap: 10px;
      grid-template-columns: 1fr;
    }
  }

  .job__desc__con {
    margin-block: 16px;
    width: 100%;
  }
  textarea {
    border-radius: 6px;
    width: 100%;
    font-size: 18px;
    padding: 10px;
    border: 1px solid #ccc;
  }
  @media screen and (max-width: 500px) {
    .job__desc__con {
      margin-block: 12px;
    }
    /* > div p {
      margin-bottom: 5px;
      font-size: 16px;
    } */
  }
`;

export default InputWrapper;
